import React, { FC } from 'react';
import { SkeletonHeadingItem, SkeletonItem } from '@atlaskit/menu';
import { selectPreferencesRequestsPending } from 'scenes/App';
import { useAppSelector } from 'hooks';
import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { PageWrapper } from '../../../../components/PageWrapper';

const styles = css({
  display: 'flex',
  flexDirection: 'column',
  padding: token('space.100'),
  maxWidth: '80%',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-selectors
  '& > div:first-of-type::after': {
    height: '12px',
  },
});

const Skeleton: FC = () => {
  const isPending = useAppSelector(selectPreferencesRequestsPending);
  if (!isPending) return null;
  return (
    <PageWrapper>
      <div data-testid='skeleton-wrapper' css={styles}>
        <SkeletonHeadingItem isShimmering={true} />
        <SkeletonItem isShimmering={true} />
        <SkeletonItem isShimmering={true} hasIcon={true} />
        <SkeletonItem isShimmering={true} hasIcon={true} />
        <SkeletonItem isShimmering={true} hasIcon={true} />
      </div>
    </PageWrapper>
  );
};

export default Skeleton;
